import { resolveUrl } from '@portals/geo-utils';

// Banner statuses
export enum EAdvertStatus {
    Unreviewed = 1, // "На проверка"
    BeingReviewed = 2, // "На модерации"
    Rejected = 3, // "Отклонена"
    Approved = 4, // "Готова к запуску"
    Trading = 5, // "Отправка на сайт"
    SentToSite = 6, // "Размещение"
    Ended = 7, // "Показы завершены"
    Surrendered = 8, // "Отказался"
    Displaying = 9, // "Активна"
    PromoConfirmed = 10, // "Промо создано"
    Paused = 11, // "Приостановлена"
    PromoEnded = 12, // "Промо завершено"
    PromoUnconfirmed = 13, // "Промо не подтверждено"
    PromoErrored = 14, // "Промо с ошибкой"
    Processing = 15, // "Промо в обработке"
    Scheduled = 16, // "Запланирована"
    ScheduleDisplaying = 17 // "На показах"
}

export enum EAdvertContentType {
    BannerBrand = 0, // Deprecated
    BannerNomenclature = 1, // Deprecated
    CarouselBrand = 2, // Deprecated
    CarouselNomenclature = 3, // Deprecated
    Catalog = 4, // Каталог  // Deprecated
    CarouselBrandAuction = 5, // "Карточка товара"  // Deprecated
    Search = 6, // "Поиск"  // Deprecated
    Recommendation = 7, // "Рекомендации"  // Deprecated
    Automatic = 8, // "Автоматическая"
    SearchCatalog = 9 // "Поиск + Каталог"
}

export const ADVERT_CONTENT_TYPE = {
    BannerBrand         : EAdvertContentType.BannerBrand,
    BannerNomenclature  : EAdvertContentType.BannerNomenclature,
    CarouselBrand       : EAdvertContentType.CarouselBrand,
    CarouselNomenclature: EAdvertContentType.CarouselNomenclature,
    Catalog             : EAdvertContentType.Catalog,
    CarouselBrandAuction: EAdvertContentType.CarouselBrandAuction,
    Search              : EAdvertContentType.Search,
    Recommendation      : EAdvertContentType.Recommendation,
    Automatic           : EAdvertContentType.Automatic,
    SearchCatalog       : EAdvertContentType.SearchCatalog
} as const;

export type TAdvertContentTypeKeys = keyof typeof ADVERT_CONTENT_TYPE;
export type TAdvertContentTypeValues = typeof ADVERT_CONTENT_TYPE[TAdvertContentTypeKeys];

export type TAdvertActualContentType =
    Omit<
    EAdvertContentType,
    EAdvertContentType.BannerBrand
    | EAdvertContentType.BannerNomenclature
    | EAdvertContentType.CarouselBrand
    | EAdvertContentType.CarouselNomenclature
    >;

export enum EActualCampaignTypes {
    Auto = 'auto', // true
    Seacat = 'seacat' // true
}

export enum ECampaignTypesWithPlacement {
    Auto = 'auto', // true
    Seacat = 'seacat', // true
    Search = 'search', // false legacy for switch type in edit page
    Catalog = 'catalog' // false legacy for switch type in edit page
}

export const DEPRECATED_CAMPAIGNS_TYPE: Record<number, 'banner' | 'carousel' | 'nm-carousel' | 'catalog' | 'carousel-auction' | 'search' | 'recom'> = {
    1: 'banner',
    2: 'carousel',
    3: 'nm-carousel',
    4: 'catalog',
    5: 'carousel-auction',
    6: 'search',
    7: 'recom'
} as const;

export const ACTUAL_CAMPAIGNS_TYPES_HASHMAP: Record<number, EActualCampaignTypes> = {
    8: EActualCampaignTypes.Auto,
    9: EActualCampaignTypes.Seacat
} as const;

export const ADVERT_TYPE_STR = {
    ...ACTUAL_CAMPAIGNS_TYPES_HASHMAP
};

export const DEPRECATED_TYPES_ID_CAMPAIGNS_HASHMAP: Record<number, number> = {
    4: EAdvertContentType.Catalog,
    5: EAdvertContentType.CarouselBrandAuction,
    6: EAdvertContentType.Search,
    7: EAdvertContentType.Recommendation,
    1: EAdvertContentType.Automatic,
    2: EAdvertContentType.SearchCatalog,
    3: EAdvertContentType.CarouselBrandAuction
} as const;

export const ACTUAL_TYPES_ID_CAMPAIGNS_HASHMAP: Record<
EActualCampaignTypes, number> = {
    [EActualCampaignTypes.Auto]  : EAdvertContentType.Automatic,
    [EActualCampaignTypes.Seacat]: EAdvertContentType.SearchCatalog
} as const;

export enum ECampaignStatus {
    Start = 'start',
    Pause = 'pause',
    Restore = 'restore',
    Stop = 'stop',
    Archive = 'archive',
    Delete = 'delete',
    Statistics = 'statistics'
}

export const CAMPAIGN_STATUS_ID = {
    [ECampaignStatus.Start]  : EAdvertStatus.Displaying,
    [ECampaignStatus.Pause]  : EAdvertStatus.Paused,
    [ECampaignStatus.Restore]: EAdvertStatus.Displaying,
    [ECampaignStatus.Stop]   : EAdvertStatus.Ended,
    [ECampaignStatus.Archive]: EAdvertStatus.Surrendered,
    [ECampaignStatus.Delete] : EAdvertStatus.Surrendered
};

export type TOrder = 'campaignName' | 'createDate' | 'pauseDate' | 'disableDate';

export type TDirection = 'asc' | 'desc';

export type TAutofill = 'all' | 'active' | 'disabled' | 'error';

export type TPaymentType = 'cpc' | 'cpm' | 'all';

export interface ISortOption {
    value: TOrder,
    direction: TDirection
}

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGINATION_PRESET = [10, 20, 30, 50];
export const DEFAULT_TYPE_FILTER = [
    EAdvertContentType.Automatic,
    EAdvertContentType.SearchCatalog
];

export const DEFAULT_TYPE_FILTER_ALL = 'All';

export const CAMPAIGN_LIST_STATUS = {
    Pause  : [EAdvertStatus.Paused],
    Active : [EAdvertStatus.Displaying],
    Archive: [EAdvertStatus.Ended, EAdvertStatus.Surrendered],
    Ready  : [EAdvertStatus.Approved],
    All    : [EAdvertStatus.Approved, EAdvertStatus.Displaying, EAdvertStatus.Paused]
};

export type TCampaignsStatuses = keyof typeof CAMPAIGN_LIST_STATUS;

export const campaignsStatusesBase: Record<Exclude<TCampaignsStatuses, 'All'>, Array<number>> = {
    'Ready'  : CAMPAIGN_LIST_STATUS.Ready,
    'Active' : CAMPAIGN_LIST_STATUS.Active,
    'Pause'  : CAMPAIGN_LIST_STATUS.Pause,
    'Archive': CAMPAIGN_LIST_STATUS.Archive
};

export const campaignsStatuses: Record<TCampaignsStatuses, Array<number>> = {
    'All': CAMPAIGN_LIST_STATUS.All,
    ...campaignsStatusesBase
};

export const campaignsStatusesForStatistics = {
    'All': [...campaignsStatuses.Active, ...campaignsStatuses.Pause],
    ...campaignsStatusesBase
};

export type TCampaignsTypes = 'All' | 'Automatic' | 'SearchCatalog';

export const campaignsTypes: Record<TCampaignsTypes, Array<number>> = {
    'All'          : DEFAULT_TYPE_FILTER,
    'Automatic'    : [EAdvertContentType.Automatic],
    'SearchCatalog': [EAdvertContentType.SearchCatalog]
};

export const PORTAL_LINK = resolveUrl('https://seller.wildberries.ru');
export const tabs = ['linear', 'funnel'] as const;

export enum EPlatformFilters {
    ALL = 'all',
    WEB = 'web',
    IOS = 'ios',
    ANDROID = 'android'
}

export enum EPlacementTypeFilters {
    ALL = 'all',
    Catalog = 'catalog',
    CarouselBrandAuction = 'carousel_brand_auction',
    Search = 'search',
    Recommendation = 'recommendation'
}

export const platformFilters = [
    EPlatformFilters.ALL,
    EPlatformFilters.WEB,
    EPlatformFilters.IOS,
    EPlatformFilters.ANDROID
];

export const placementTypeFilters = [
    EPlacementTypeFilters.ALL,
    EPlacementTypeFilters.Catalog,
    EPlacementTypeFilters.CarouselBrandAuction,
    EPlacementTypeFilters.Search,
    EPlacementTypeFilters.Recommendation
] as const;

type TPlacementTypeFilterByAdvertContentType = Partial<Record<EActualCampaignTypes, Readonly<Array<EPlacementTypeFilters>>>>;

export const placementTypeFilterByAdvertContentType: TPlacementTypeFilterByAdvertContentType = {
    [EActualCampaignTypes.Auto]: [
        EPlacementTypeFilters.ALL,
        EPlacementTypeFilters.Catalog,
        EPlacementTypeFilters.Search,
        EPlacementTypeFilters.CarouselBrandAuction
    ],
    [EActualCampaignTypes.Seacat]: [EPlacementTypeFilters.ALL, EPlacementTypeFilters.Catalog, EPlacementTypeFilters.Search]
} as const;

export const statisticsPlatforms: Record<typeof platformFilters[number], number> = {
    [EPlatformFilters.ALL]    : 0,
    [EPlatformFilters.WEB]    : 1,
    [EPlatformFilters.IOS]    : 64,
    [EPlatformFilters.ANDROID]: 32
};

export const statisticsPlacementTypes: Record<typeof placementTypeFilters[number], number> = {
    [EPlacementTypeFilters.ALL]                 : 0,
    [EPlacementTypeFilters.Search]              : 1,
    [EPlacementTypeFilters.Catalog]             : 2,
    [EPlacementTypeFilters.CarouselBrandAuction]: 3,
    [EPlacementTypeFilters.Recommendation]      : 4
};

export const ITEMS_ON_PAGE_IN_RATE = 12;

export const ITEMS_ON_PAGE_IN_CREATE_CAMPAIGN = 300;
